/* The prototype's `.tile` — a number, a label, and an optional line of
   provenance. Used for the pushed status row on the dashboard and the summary
   row on Expiries. Deliberately not a StatCard: a tile is a fact, a stat card is
   a link into a register. */

import type { ReactNode } from 'react';
import s from './screens.module.scss';

export function Tile({
  icon,
  value,
  label,
  foot,
  tone,
  title,
}: {
  icon: string;
  value: ReactNode;
  label: ReactNode;
  foot?: ReactNode;
  tone?: 'ok' | 'warn' | 'bad';
  title?: string;
}) {
  const toneClass = tone === 'ok' ? s.tileOk : tone === 'warn' ? s.tileWarn : tone === 'bad' ? s.tileBad : '';
  return (
    <div className={s.tile} title={title}>
      <span className={`${s.tileIcon} ${toneClass}`}>
        <i className={`ti ${icon}`} aria-hidden />
      </span>
      <div className={s.min0}>
        <b className={s.tileValue}>{value}</b>
        <span className={s.tileLabel}>{label}</span>
        {foot && <span className={s.tileSrc}>{foot}</span>}
      </div>
    </div>
  );
}

export function Tiles({ children }: { children: ReactNode }) {
  return <div className={s.tiles}>{children}</div>;
}
